import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageService } from '@core/services';
import { SKIP_LANGUAGE } from '@/core/services/skip-language-interceptor';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private readonly languageService = inject(LanguageService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_LANGUAGE)) {
      return next.handle(request);
    }
    const current = +(localStorage.getItem('language') ?? '1') || this.languageService.currentLanguage();
    const currentLanguage = request.url.includes('uiLabels') ? current : this.languageService.currentLanguage();
    request = request.clone({
      setHeaders: {
        'X-Language': `${currentLanguage}`,
      },
    });
    return next.handle(request);
  }
}
